import * as React from 'react'
import {importReg} from '../../dispatchers/appRegImportDispatcher'
import {connect} from 'react-redux'
import {IAppStore} from '../../interfaces/reducers'
import {IConnectValidationData, IImportActionData} from '../../interfaces/reducers/IRegImport'

interface OwnProps {
  importActionData: IImportActionData
  connectValidationData: IConnectValidationData
}

interface ParentProps {}

interface DispatchProps {
  importReg: typeof importReg
}

type Props = DispatchProps & ParentProps & OwnProps

const RegImportActionClass = (props: Props) => {
  const getSuccessData = () => {
    return (
      <div className="import-params-success">
        <div>Успешен импорт</div>
      </div>
    )
  }
  const getValidationStatusUI = () => {
    if (props.importActionData.loading) {
      if (props.importActionData.success) {
        return getSuccessData()
      }
      return <div className="import-loading">В процес на импорт...</div>
    } else {
      if (props.importActionData.errors && props.importActionData.errors.length > 0) {
        const errors: JSX.Element[] = []
        props.importActionData.errors.forEach((e, i) => {
          errors.push(<div key={i}>{e}</div>)
        })
        return (
          <div className="import-params-errors">
            <div>Грешки при импорт:</div>
            {errors}
          </div>
        )
      } else if (props.importActionData.success) {
        return getSuccessData()
      }
    }
  }
  if (!props.connectValidationData.successData) {
    return <div></div>
  }
  return (
    <div style={{padding: '10px', boxSizing: 'border-box'} as React.CSSProperties}>
      {getValidationStatusUI()}
      {props.importActionData.success || props.importActionData.loading ? null : (
        <div style={{width: '100%'}}>
          {props.connectValidationData.successData!.IsNewPlan &&
          props.connectValidationData.successData!.PreviousPlans.length > 0 ? (
            <div className="import-params-warnings">
              <div>При импорт на НОВ план всички данни за местността отиват в история</div>
              <div>Предишни планове: {props.connectValidationData.successData!.PreviousPlans.join(', ')}</div>
            </div>
          ) : null}
          {props.connectValidationData.successData!.NextPlans.length > 0 ? (
            <div className="import-params-warnings">
              <div>На път сте да импортирате изменение преди вече създадени изменения</div>
              <div>
                Изменението ще бъде приложено, но може да не се отрази визуално в случай че обектите в него са вече
                изменени от импорти : {props.connectValidationData.successData!.NextPlans.join(', ')}{' '}
              </div>
            </div>
          ) : null}
          <button
            type="button"
            className="button width"
            onClick={() => {
              props.importReg(props.connectValidationData.successData!.importPath)
            }}
          >
            ИМПОРТ
          </button>
        </div>
      )}
    </div>
  )
}

const mapStoreToProps = (store: IAppStore) => ({
  importActionData: store.regImport.importActionData,
  connectValidationData: store.regImport.connectValidationData
})

export const RegImportAction = connect<OwnProps, DispatchProps, ParentProps>(mapStoreToProps, {importReg})(
  RegImportActionClass
)
